import React from "react";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import LoginForm from "../components/Web/Login/LoginForm";
import { useSelectorApp } from "../lib/redux";

const Login = () => {
  const { theme } = useSelectorApp((state) => state.ui);

  return (
    <Container
      maxWidth="xs"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Avatar
        src={theme.logoLogin}
        alt="Logo"
        variant="square"
        sx={{
          width: "auto",
          height: "auto",
          maxHeight: "60px",
          ".MuiAvatar-img": {
            maxWidth: "160px",
            objectFit: "contain",
          },
          mb: 1,
        }}
      />
      <LoginForm />
    </Container>
  );
};

export default Login;
